import Vue from 'vue';
import Vuex from 'vuex';
import ElementUI from 'element-ui';
import AuthComponent from './components/Auth.vue';
import LoginComponent from './components/Login.vue';
import RegisterComponent from './components/Register.vue';
import RecoverComponent from './components/Recover.vue';
import notification_header from './components/EshopNotificationsHeader';
import authStore from './auth-store';
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.component('auth', AuthComponent);
Vue.component('login', LoginComponent);
Vue.component('register', RegisterComponent);
Vue.component('recover', RecoverComponent);

Vue.component('message', {
  template: `
    <div>
      <div style="padding-bottom: 12px">
        <p>{{ message }}</p>
        <p><a @click="goBack">{{ backLabel }}</a></p>
      </div>
    </div>
  `,
  methods: {
    goBack() {
      this.$store.commit('auth/loadComponent', 'login');
    }
  },
  computed: {
    message() {
      return this.$store.state.auth.message;
    },
    backLabel() {
      return $r.auth_back;
    },
  }
});

const store = new Vuex.Store({
  modules: {
    auth: authStore,
  }
});

new Vue({
  el: '#eshop_login',
  components : {notification_header},
  store,
  computed: {
    cartCount() {
      return window.cartCount;
    }
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if(mutation.type == 'auth/setAuthorized') {
        window.location = window.urlAfterLogin;
      }
    });
  }
});
